import { Helmet } from "react-helmet-async";

/**
 * SEO component — sets <title>, meta description, Open Graph, Twitter card,
 * canonical URL, and optional JSON-LD schema for any page.
 *
 *   <SEO
 *     title="Cromwell 25 — Plato Collection"
 *     description="..."
 *     image="/uploads/.../hero.jpg"
 *     canonical="https://brand.com/home-designs/plato-collection/cromwell-25"
 *     schema={{ "@context": "https://schema.org", "@type": "Product", ... }}
 *   />
 */
export function SEO({ title, description, image, canonical, schema, type = "website" }) {
  const fullTitle = title
    ? `${title} | Shere-e-Punjab Homes`
    : "Shere-e-Punjab Homes — Custom Home Builder";
  const desc = description ?? "Bespoke custom homes across Melbourne.";
  const fullImage = image?.startsWith("http")
    ? image
    : image
      ? `${import.meta.env.VITE_PUBLIC_ASSET_BASE ?? "http://localhost:4000"}${image}`
      : undefined;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      {canonical && <link rel="canonical" href={canonical} />}

      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:type" content={type} />
      {fullImage && <meta property="og:image" content={fullImage} />}
      {canonical && <meta property="og:url" content={canonical} />}

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      {fullImage && <meta name="twitter:image" content={fullImage} />}

      {/* JSON-LD */}
      {schema && <script type="application/ld+json">{JSON.stringify(schema)}</script>}
    </Helmet>
  );
}
